import { createSelector } from '@reduxjs/toolkit';
import type { IUserProfileClientInfo } from '../../types/userProfile';
import { userProfileSelector } from './userProfileSelector';

export const userProfileClientInfoSelector = createSelector(
  [userProfileSelector],
  (profile): IUserProfileClientInfo | null => {
    return profile?.clientInfo || null;
  },
);
